export default {
  carregando: false,
  carregandoConfiguracao: false,
  configuracaoIntegracao: null,
  carregandoDashboard: false,
  dashboardCentroFuncional: {
    provedores: [],
    totais: { telmex: 0, claro_geral: 0, total: 0 }
  },
  paginacaoDashboard: {
    per_page: 20,
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 0,
    to: 0
  },
  items: [],
  paginacao: {
    per_page: 20,
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 1,
    to: 0
  },
  selecionado: {
    id: null,
    numero_rec: '',
    processado: false,
    processado_em: null,
    tem_external: null,
    tentativas_processamento: 0,
    erro_processamento: null,
    created_at: null,
    payload_original: null
  }
}